import { FC } from 'react';
import { useAppSelector } from '../../app/hooks';
import { selectSessionBankName } from '../../app/slices/bank.slice';
import StepHeader from '../StepHeader';
import { Box, Stack } from '@mui/material';
import styles from '../../assets/css/header.module.css';
import { SubmitButton } from '../form/SubmitButton';
import SupportSection from '../auth-rejected/SupportSection';
import { useAppTranslation } from '../../i18n';

const ConsentExpiredStep: FC = () => {
	const bankName = useAppSelector(selectSessionBankName)!;
	const { t } = useAppTranslation();

	const onSubmit = () => {
		// refresh browser to retry authentication
		window.location.reload();
	};

	return (
		<Stack
			id="consent-expired-step"
			direction="column"
			spacing={2}
			alignItems="center"
			justifyContent="center"
			sx={{ boxSizing: 'border-box', width: '100%' }}
		>
			<StepHeader
				title={t('consent-expired-step.title')}
				bankName={bankName}
				subtitle={t('consent-expired-step.subtitle')}
			/>
			<Stack
				className={styles['step-header-text-div']}
				alignItems="center"
				justifyContent="center"
				sx={{ m: 0, p: 0 }}
			>
				<span className={styles['step-header-text']}>{t('consent-expired-step.explanation-message-1')}</span>
				<br />
				<span className={styles['step-header-text']}>{t('consent-expired-step.explanation-message-2')}</span>
			</Stack>
			<Box sx={{ width: '75%' }}>
				<SubmitButton
					text={t('consent-expired-step.button-message')}
					onSubmit={onSubmit}
					submitting={false}
					disabled={false}
				/>
			</Box>
			<Box
				className={styles['step-header-text-div']}
				alignItems="center"
				justifyContent="center"
				style={{ marginTop: '20px' }}
			>
				<SupportSection />
			</Box>
		</Stack>
	);
};

export default ConsentExpiredStep;
